import { protectedRoutes } from '@/routes/config';
import {
  createRoutePreloader,
  preloadRouteForPath,
} from '@gokrew/ui/utility/createRoutePreloader';

export const preloadRoutes = createRoutePreloader(protectedRoutes);

/**
 * Downloads the page this URL opens while the session is still being restored.
 * A visitor with no session is about to be sent to the login page, so skip them.
 */
export const preloadCurrentRoute = () => {
  if (!localStorage.getItem('employee_portal_sessionId')) return;
  preloadRouteForPath(protectedRoutes, window.location.pathname);
};
